import { Typography } from "antd";
import { TagItemTypes } from "../../../badge-and-tag/ERP";
/** get items column */

export const columns = ({})=>{
  const Link = Typography.Link;
  const LChoose = ({children, record}) => (
    <Link 
    className="text-select" 
    disabled={record?.active_status === 'ปิดการใช้งาน'} >{children}</Link>
  );
  return [
    {
      title: "รหัสสินค้า",
      key: "stcode",
      dataIndex: "mat_code", 
      align: "left",
      width:"15%",
      sorter: (a, b) => (a?.mat_code || "").localeCompare(b?.mat_code || ""),
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
    // {
    //   title: "ประเภทสินค้า",
    //   key: "typename",
    //   dataIndex: "typename", 
    //   align: "left",
    //   width:"15%",
    //   sorter: (a, b) => (a?.typename || "").localeCompare(b?.typename || ""),
    //   render: (v, record) => <LChoose record={record}>{v}</LChoose>
    // },
     {
      title: "ประเภทสินค้า",
      dataIndex: "typename",
      key: "typename",
      sorter: (a, b) => (a?.typename || "").localeCompare(b?.typename || ""),
      width:"17%",
      sortDirections: ["descend", "ascend"],
      render: (data) => <LChoose ><TagItemTypes data={data} /></LChoose>,
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "mat_name",
      key: "mat_name",
      sorter: (a, b) => (a?.mat_name || "").localeCompare(b?.mat_name || ""),
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
  ]
};